import { FASTElement } from "@microsoft/fast-element";
/**
 * MultiViewController
 * @summary A customizable controller component for a multi-view interface.
 *
 * @example
 * ```html
 * <fabric-multi-view-controller hidden>
 *   <fabric-multi-view-group>
 *     <fabric-multi-view>
 *       <!-- Content for the first view -->
 *     </fabric-multi-view>
 *     <fabric-multi-view>
 *       <!-- Content for the second view -->
 *     </fabric-multi-view>
 *   </fabric-multi-view-group>
 * </fabric-multi-view-controller>
 * ```
 *
 * @attr {boolean} hidden - Controls the visibility of the component. True if the component is hidden.
 *
 * @prop {boolean} hidden - Controls the visibility of the component. True if the component is hidden.
 *
 * @slot - Default slot for adding a controller.
 *
 * @csspart multi-view - Style part for the main container of the multi-view.
 *
 * @extends FASTElement
 * @tagname fabric-multi-view-controller
 * @public
 */
export class MultiViewController extends FASTElement {
}
//# sourceMappingURL=multi-view-controller.js.map